import { Box, Button, Grid, useTheme } from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddCircle';
import {
  getTemplate,
  getUiOptions,
  ObjectFieldTemplateProps,
  canExpand,
} from '@rjsf/utils';
import { isHidden } from '../../utils';

interface DefaultObjectFieldTemplateProperties {
  displayTitle: boolean;
}

function parseDefaultObjectFieldTemplateProperties(
  props: ObjectFieldTemplateProps,
): DefaultObjectFieldTemplateProperties {
  const inputDisplayTitle = props?.uiSchema?.['ui:options']?.displayTitle;

  const displayTitle: boolean =
    typeof inputDisplayTitle === 'boolean' ? inputDisplayTitle : true;
  return {
    displayTitle,
  };
}

export const DefaultObjectFieldTemplate = (props: ObjectFieldTemplateProps) => {
  const {
    description,
    title,
    properties,
    required,
    disabled,
    readonly,
    uiSchema,
    idSchema,
    schema,
    formData,
    registry,
    onAddClick,
  } = props;
  const { displayTitle } = parseDefaultObjectFieldTemplateProperties(props);
  const theme = useTheme();
  const uiOptions = getUiOptions(uiSchema);
  const TitleField = getTemplate('TitleFieldTemplate', registry, uiOptions);
  const DescriptionField = getTemplate(
    'DescriptionFieldTemplate',
    registry,
    uiOptions,
  );

  return (
    <Box style={{ display: isHidden(uiSchema) ? 'none' : undefined }}>
      {displayTitle && (
        <Box margin={`${theme.spacing(1)}px 0px`}>
          {(uiSchema?.['ui:title'] || title) && (
            <TitleField
              id={`${idSchema.$id}-title`}
              title={title}
              required={required}
              schema={schema}
              registry={registry}
            />
          )}
          {description && (
            <DescriptionField
              id={`${idSchema.$id}-description`}
              description={description}
              schema={schema}
              registry={registry}
            />
          )}
        </Box>
      )}
      <Grid container spacing={2} style={{ marginTop: '10px' }}>
        {properties.map((element, index) =>
          // Remove the <Grid> if the inner element is hidden as the <Grid>
          // itself would otherwise still take up space.
          element.hidden ? (
            element.content
          ) : (
            <Grid item xs={12} key={index} style={{ marginBottom: '10px' }}>
              {element.content}
            </Grid>
          ),
        )}
        {canExpand(schema, uiSchema, formData) && (
          <Grid container justifyContent="flex-end">
            <Grid item>
              <Button
                className="object-property-expand"
                onClick={onAddClick(schema)}
                disabled={disabled || readonly}
                color="secondary"
              >
                <AddIcon /> Add Item
              </Button>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Box>
  );
};
